export const dataVouchersDetailsTypes = {
    loading: "[dataVouchersDetails] loading",
    partialLoad: "[dataVouchersDetails] partialLoad",
    load: "[dataVouchersDetails] load",
    reload: "[dataVouchersDetails] reload",
    error: "[dataVouchersDetails] error",
    clean: "[dataVouchersDetails] clean",
};
